module.exports = __webpack_public_path__ + "static/media/downarrowsvg.16dee714.svg";